import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'loader-three-dots',
	templateUrl: './three-dots.component.html',
	styleUrls: ['./three-dots.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [],
	host: {
		class: 'flex items-center justify-center  ',
	},
})
export class LoaderThreeDotsComponent {}
